import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const chunkedCategories = [];
  for (let i = 0; i < categories.length; i += 5) {
    chunkedCategories.push(categories.slice(i, i + 5));
  }

  return (
    <footer className="py-14 md:py-16 px-4 md:px-6 bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10">
          {/* Left - Brand */}
          <div className="lg:w-[35%]">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-2xl text-foreground-950 tracking-tight">
                Pandabuy<span className="text-primary-500">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-sm">
              Your go-to resource for the best Pandabuy spreadsheet finds. Curated fashion, sneakers, and accessories updated daily.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit Pandabuy Sheet
              <i className="ri-arrow-right-up-line text-base group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
          </div>

          {/* Right - Category Links */}
          <div className="lg:w-[65%]">
            <p className="text-sm font-semibold text-foreground-800 mb-4">Browse Categories</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-8 gap-y-2.5">
              {chunkedCategories.map((chunk, colIdx) => (
                <div key={colIdx} className="flex flex-col gap-2.5">
                  {chunk.map((cat) => (
                    <a
                      key={cat.id}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-500 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-12 pt-6 border-t border-background-200/60">
          <p className="text-xs text-foreground-400">
            &copy; 2026 PandabuySheet. All external links direct to our partner site.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <Link to="/pandabuy-spreadsheet-guide" className="hover:text-foreground-700 transition-colors cursor-pointer">
              Buying Guide
            </Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-foreground-700 transition-colors">
              Pandabuy Sheet
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}